'use strict';

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('fetch-everywhere');

var FetchGithubRepo = function FetchGithubRepo(repository) {
  return fetch('https://api.github.com/repos/' + repository).then(function (response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }

    return response;
  }).then(function (response) {
    return response.json();
  }).then(function (repo) {
    return Promise.resolve(repo);
  })["catch"](function () {
    return Promise.reject(new Error('GitHub API has throttled your IP.'));
  });
};

exports["default"] = FetchGithubRepo;
module.exports = exports['default'];